// /src/pages/private/members/academyTools/components/AcademyDocumentListRow.jsx

import React from 'react';
import useDocumentPreview from '../hooks/useDocumentPreview';

export default function AcademyDocumentListRow({ document, onOpenDocument }) {
  const { excerpt, loadingExcerpt } = useDocumentPreview(document.documentName);

  return (
    <button
      type="button"
      className="member-academy-document-row"
      onClick={() => onOpenDocument(document)}
      data-resource="private.navbar.academy"
      data-action="read"
      data-route="/api/admin/lexical/retrieve-member-html-document"
      data-description="Academy → Open document"
    >
      <div className="member-academy-document-row__main">
        <span className="member-academy-document-row__title">{document.label}</span>
        {document.version ? (
          <span className="member-academy-document-row__meta">v{document.version}</span>
        ) : null}
      </div>
      <div className="member-academy-document-row__excerpt-wrap">
        {loadingExcerpt ? (
          <span className="member-academy-document-row__excerpt member-academy-document-row__excerpt--loading">
            Loading preview…
          </span>
        ) : excerpt ? (
          <p className="member-academy-document-row__excerpt">{excerpt}</p>
        ) : null}
      </div>
    </button>
  );
}
